import * as d3 from 'd3';
import _ from 'lodash';

const dateTimePattern = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d*Z/;
const datePattern = /\d{4}-\d{2}-\d{2}/;
const numberPattern = /^\d+$/i;
const uuidPattern = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export const isDate = (term: string): boolean => {
    return datePattern.exec(term) !== null;
};

export const isDateTime = (term: string): boolean => {
    return dateTimePattern.exec(term) !== null;
};

export const isNumber = (term: string): boolean => {
    return numberPattern.exec(term) !== null;
};

export const isUuid = (term: string): boolean => {
    return uuidPattern.exec(term) !== null;
};

export const isValidEmail = (str: string): boolean =>
    new RegExp(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i).test(str);

export const betweenDayBoundsFilter = (date: string): string[] | undefined => {
    if (date) {
        const day = new Date(date);
        const startOfDay = d3.utcDay.floor(day).toISOString();
        const endOfDay = d3.utcDay.offset(d3.utcSecond.offset(day), 1).toISOString();
        return [`${startOfDay}:${endOfDay}`];
    }
};

export const equalsFilter = (term?: string | string[]): string[] | undefined => {
    if (_.isArray(term)) {
        return [`EQ:${_.join(term, ',')}`];
    } else if (_.isString(term)) {
        return [`EQ:${term}`];
    }
};

export const firstAndLastFilter = (term?: string): { filterFirst?: string[]; filterLast?: string[] }[] => {
    // term 'abc' should result in 'filterFirst: abc OR filterLast: abc', which is 2 requests
    // term 'abc def' should result in  'filterFirst: abc AND filterLast: def', in 1 request
    if (term) {
        const parts = _.split(term || '', ' ');
        if (parts.length === 1) {
            return [
                {
                    filterFirst: likeFilter(parts[0]),
                },
                {
                    filterLast: likeFilter(parts[0]),
                },
            ];
        }
        return [
            {
                filterFirst: likeFilter(parts[0]),
                filterLast: likeFilter(parts[1]),
            },
        ];
    }
    return [];
};

export const accountNumberFilter = (term?: string): { filterAccountNumber?: string[] }[] => {
    if (!term) {
        return [];
    }

    return [
        {
            filterAccountNumber: equalsFilter(term),
        },
    ];
};
export const likeFilter = (term?: string | string[]): string[] | undefined => {
    if (_.isArray(term)) {
        return [_.map(term, d => `LK:${d}`).join(',')];
    } else if (_.isString(term)) {
        return [`LK:${term}`];
    }
};
